import { PropBinding } from './PropBinding';

/**
 * parse binding
 *
 * @export
 * @class OneWayBinding
 * @extends {PropBinding<T>}
 * @template T
 */
export abstract class ParseBinding<T> extends PropBinding<T> {


                    static ρAnn(): any {
                        return {"name":"ParseBinding"};
                    }
               }
